var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "aside-left-wrap" },
    [
      _c("div", { staticClass: "top" }, [
        _c("div", { staticClass: "avatar-box" }, [
          _c("div", {
            staticClass: "avatar",
            style: { backgroundImage: `url(${_vm.user.portrait})` },
          }),
        ]),
        _c("span", { staticClass: "name" }, [
          _vm._v(_vm._s(_vm.user.userName)),
        ]),
        _c(
          "div",
          { staticClass: "opts" },
          [
            _c(
              "el-tooltip",
              { attrs: { content: _vm.$t("btn_resetPassword") } },
              [
                _c(
                  "div",
                  { staticClass: "item", on: { click: _vm.resetPassword } },
                  [_c("i", { staticClass: "el-icon-lock" })]
                ),
              ]
            ),
            _c("el-tooltip", { attrs: { content: _vm.$t("configTimeout") } }, [
              _c(
                "div",
                { staticClass: "item", on: { click: _vm.configTimeout } },
                [_c("i", { staticClass: "el-icon-setting" })]
              ),
            ]),
            _c("el-tooltip", { attrs: { content: _vm.$t("login_out") } }, [
              _c(
                "div",
                { staticClass: "item", on: { click: _vm.loginOut } },
                [
                  _c("svg-icon", {
                    staticStyle: { position: "relative", bottom: "1px" },
                    attrs: {
                      "icon-name": "log_out",
                      "icon-color": "#1e49e2",
                      size: 12,
                    },
                  }),
                ],
                1
              ),
            ]),
          ],
          1
        ),
      ]),
      _c("div", { staticClass: "mid" }, [
        _c("div", { staticClass: "__title" }, [
          _c("img", {
            attrs: { src: require("@/assets/img/home_workbench.svg"), alt: "" },
          }),
          _vm._v("\n      " + _vm._s(_vm.$t("workbench")) + "\n    "),
        ]),
        _c(
          "div",
          { staticClass: "__content" },
          [_c("site-list", { attrs: { siteIds: _vm.siteIds } })],
          1
        ),
      ]),
      _c("div", { staticClass: "bottom" }, [
        _c("div", { staticClass: "connect-us" }, [
          _c("img", {
            attrs: { src: require("@/assets/img/Cantact_KCC_Team.png") },
          }),
          _c(
            "a",
            {
              attrs: { target: "_top", href: "mailto:cnfmkpmgclicbt@kpmg.com" },
            },
            [_vm._v(_vm._s(_vm.$t("newsMgt.contactTeam")))]
          ),
        ]),
        _c("div", { staticClass: "videos" }, [
          _c("img", {
            attrs: { src: require("@/assets/img/introduction_video_bg.png") },
          }),
          _c("div", { staticClass: "_r" }, [
            _c("div", { staticClass: "_t" }, [
              _vm._v(
                "\n          " +
                  _vm._s(_vm.$t("newsMgt.videoList.introductionClient")) +
                  "\n        "
              ),
            ]),
            _c(
              "a",
              {
                on: {
                  click: function ($event) {
                    return _vm.renderVideo("en")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("newsMgt.videoList.en")))]
            ),
            _c(
              "a",
              {
                on: {
                  click: function ($event) {
                    return _vm.renderVideo("cn")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("newsMgt.videoList.cn")))]
            ),
            _c(
              "a",
              {
                on: {
                  click: function ($event) {
                    return _vm.renderVideo("yueyu")
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("newsMgt.videoList.yueyu")))]
            ),
          ]),
        ]),
      ]),
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.$t("configTimeoutDialogTitle"),
            visible: _vm.timeoutVisible,
            width: "20%",
            "show-close": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.timeoutVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "center" },
            [
              _c("el-input-number", {
                attrs: { precision: 1, step: 0.5, max: 8, min: 0.5 },
                model: {
                  value: _vm.outTime,
                  callback: function ($$v) {
                    _vm.outTime = $$v
                  },
                  expression: "outTime",
                },
              }),
              _vm._v("\n      " + _vm._s(_vm.$t("hour")) + "\n      "),
              _c(
                "div",
                {
                  staticClass: "tip",
                  staticStyle: { color: "#fd349c", "text-align": "left" },
                },
                [
                  _c("i", { staticClass: "el-icon-info" }),
                  _vm._v(
                    "\n        " + _vm._s(_vm.$t("outTimeTips")) + "\n      "
                  ),
                ]
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.setOutTime } },
                [_vm._v(_vm._s(_vm.$t("btn_confirm")))]
              ),
            ],
            1
          ),
        ]
      ),
      _vm.videoListShow
        ? _c("short-videos", { attrs: { onCancel: _vm.toogleVideoShow } })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }